export class SyncTimestampDto {
  timestamp: Date;
  archived: boolean;

  constructor(public _id: string, public latestTimestamp: Date) {
    this.timestamp = new Date();
  }
}
